// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_user__qDPq2 {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}
.style_user__part__IzGoG {
  width: 100%;
  position: absolute;
  z-index: 12;
}

.style_balance__dOt8R {
  max-width: 350px;
  margin: 0 auto;
  position: relative;
}
@media screen and (min-height: 600px) {
  .style_balance__dOt8R {
    margin-top: 32px;
  }
}

.style_join__wrapper__6ibnZ {
  display: flex;
  justify-content: center;
  margin-top: 14px;
}

.style_join__R1NSm {
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
}

.style_double__border__is62g {
  color: rgb(255, 255, 255);
  font-size: 1.6rem;
  width: 140px;
  display: flex;
  justify-content: center;
  padding: 10px 0;
  border: 2px solid rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  overflow: hidden;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}
.style_double__border__is62g i {
  color: rgb(255, 255, 255);
  font-size: 2.4rem;
}

.style_double__border__is62g::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 10px;
  border: 2px solid rgb(255, 216, 11);
  box-sizing: border-box;
  animation: style_pulse__VpHeY 1.5s infinite ease-out;
  pointer-events: none;
  z-index: 1;
}

@keyframes style_pulse__VpHeY {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1.3);
    opacity: 0;
  }
}
.style_streak__oDryf {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  font-size: 16px;
  font-weight: 500;
  gap: 4px;
  position: fixed;
  bottom: 210px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  min-width: 150px;
  width: 100%;
  color: rgb(255, 214, 48);
}
.style_streak__oDryf img {
  width: 18px;
  height: 18px;
}`, "",{"version":3,"sources":["webpack://./src/features/tower/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AADF;AAEE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;AADF;AAEE;EAJF;IAKI,gBAAA;EACF;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;EAAA,kBAAA;AACF;;AAEA;EACE,yBC9BM;ED+BN,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,2CAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AACF;AAAE;EACE,yBC7CI;ED8CJ,iBAAA;AAEJ;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,mCAAA;EACA,sBAAA;EACA,oDAAA;EACA,oBAAA;EACA,UAAA;AACF;;AAEA;EACE;IACE,mBAAA;IACA,UAAA;EACF;EACA;IACE,qBAAA;IACA,UAAA;EACF;AACF;AAEA;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,wBAAA;AAAF;AACE;EACE,WAAA;EACA,YAAA;AACJ","sourcesContent":["@import '../../../public/assets/colors';\n\n.user {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n  &__part {\n    width: 100%;\n    position: absolute;\n    z-index: 12;\n  }\n}\n\n.balance {\n  max-width: 350px;\n  margin: 0 auto;\n  position: relative;\n  @media screen and (min-height: 600px) {\n    margin-top: 32px;\n  }\n}\n\n.join__wrapper {\n  display: flex;\n  justify-content: center;\n  margin-top: 14px;\n}\n\n.join {\n  position: relative;\n  width: fit-content;\n}\n\n.double__border {\n  color: $white;\n  font-size: 1.6rem;\n  width: 140px;\n  display: flex;\n  justify-content: center;\n  padding: 10px 0;\n  border: 2px solid rgba(255, 255, 255, 0.25);\n  border-radius: 10px;\n  overflow: hidden;\n  outline: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  i {\n    color: $white;\n    font-size: 2.4rem;\n  }\n}\n\n.double__border::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 10px;\n  border: 2px solid rgba(255, 216, 11, 1);\n  box-sizing: border-box;\n  animation: pulse 1.5s infinite ease-out;\n  pointer-events: none;\n  z-index: 1;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1.3);\n    opacity: 0;\n  }\n}\n\n.streak {\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  font-size: 16px;\n  font-weight: 500;\n  gap: 4px;\n  position: fixed;\n  bottom: 210px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 9999;\n  min-width: 150px;\n  width: 100%;\n  color: rgba(255, 214, 48, 1);\n  img {\n    width: 18px;\n    height: 18px;\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"user": `style_user__qDPq2`,
	"user__part": `style_user__part__IzGoG`,
	"balance": `style_balance__dOt8R`,
	"join__wrapper": `style_join__wrapper__6ibnZ`,
	"join": `style_join__R1NSm`,
	"double__border": `style_double__border__is62g`,
	"pulse": `style_pulse__VpHeY`,
	"streak": `style_streak__oDryf`
};
export default ___CSS_LOADER_EXPORT___;
